// extracted by mini-css-extract-plugin
export default {"create-report-popup":"CreateReportPopup_create-report-popup__N-T8j","popup-header":"CreateReportPopup_popup-header__A2203"};